export enum SUPPORTED_CALENDARS {
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  OUTLOOK = 'OUTLOOK',
}
